import { Eye } from 'lucide-react';
import { JSX } from 'react';

import {
  TYPE_SCALE,
  GAP_SCALE,
  SIZE_SCALE,
  PADDING_X,
  PADDING_Y,
  RADIUS_SCALE,
  COLOR_SCALE,
  WHITESPACE,
} from '@/components/design-system/tokens';
import { useTranslation } from '@/hooks/useTranslation';

interface RecentlyViewedBadgeProps {
  timeText?: string;
  className?: string;
  lightBackground?: boolean;
}

/**
 * Badge to indicate a provider was recently viewed by the user
 */
export default function RecentlyViewedBadge({
  timeText,
  className = '',
  lightBackground = false,
}: RecentlyViewedBadgeProps): JSX.Element {
  const { t } = useTranslation();
  const displayText = timeText ?? t('ui_components', 'recently_viewed', 'Recently Viewed');

  const textColorClass = 'text-white';
  const bgClass = lightBackground ? `${COLOR_SCALE.surface}/40` : 'bg-black/40';

  return (
    <div
      className={`${bgClass} backdrop-blur-sm ${textColorClass} ${TYPE_SCALE['3xs']} flex items-center ${GAP_SCALE['1']} font-medium ${PADDING_X['2']} ${PADDING_Y['1']} ${RADIUS_SCALE.md} ${className}`}
    >
      <Eye className={`${SIZE_SCALE.w3} ${SIZE_SCALE['3']} flex-shrink-0 text-white`} />
      <span className={`${WHITESPACE.nowrap} text-white`} style={{ color: '#ffffff' }}>
        {displayText}
      </span>
    </div>
  );
}
